import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutFmProfileDataOutputTable extends Layout {
    sourceFreightMatchingProfileDataOutput: DataSource;
    tableFmDataOutput: Table;
}
